
import { defineComponent } from "@vue/composition-api";
import { MultiTenancyService } from "./services/multi-tenancy";
export default defineComponent({
  name: "App",
  watch: {
    '$i18n.locale': function() {
      if (this.$route.meta && this.$route.meta.title) {
        document.title = this.$t(this.$route.meta.title) + " - " + MultiTenancyService.getTenantConfig().contents.company.shortName /* process.env.VUE_APP_NAME */;
      }
    }
  },
});
